import React from "react";
import { Link } from "react-router-dom";
import Navigation from "../navbar/navbar.jsx";
import Footer from "../footer/footer.jsx";
import AnimatedSection from "../components/AnimatedSection.jsx";
import { FaInstagram, FaLinkedin, FaGithub } from "react-icons/fa";
import { translations } from '../utils/translations.js';

const PortfolioHome = ({ language, setLanguage, isDarkMode, setIsDarkMode }) => {
  // Get translations for current language
  const t = translations[language || 'es'];

  // Use props directly (no local state needed since App.js manages global state)
  const darkMode = isDarkMode || false;
  const currentLanguage = language || 'es';
    // No form-related code needed in home component
  //wave text
  const WaveText = () => {
    return (
      <div className="fixed inset-0 pointer-events-none z-10 overflow-hidden">
        <div className="absolute w-[200%] h-full animate-pulse">
        </div>
      </div>    );  };
  
  //me section
  const HeroSection = () => {
    return (
      <section className="h-screen bg-red-900 text-white flex items-center justify-center px-4 sm:px-8 lg:px-12 pt-28">
        <div className="w-full flex items-center justify-center -ml-4 sm:-ml-6 lg:-ml-2">
          <div className="relative w-[90vw] h-[90vw] sm:w-[85vw] sm:h-[85vw] md:w-[40rem] md:h-[40rem] lg:w-[48rem] lg:h-[48rem] xl:w-[55rem] xl:h-[55rem] 2xl:w-[65rem] 2xl:h-[65rem]">
            <img 
              key={isDarkMode ? 'dark' : 'light'}
              src={isDarkMode ? "/img/logo-portfolio-black.png" : "/img/logo-portfolio.png"}
              alt="Logo Portfolio"
              className="absolute inset-0 w-full h-full object-contain transition-all duration-300"
            />
          </div>
        </div>
      </section>
    );
  };
  
  //explore Section
  const ExploreSection = () => {
    const sections = [
      {
        title: t.knowledgeTitle,
        image: "bg-gradient-to-br from-gray-200 to-gray-400",
        imgSrc: darkMode ? "/img/studying-white.png" : "/img/studying.png",
        link: "/conocimientos"
      },
      {
        title: t.experienceTitle,
        image: "bg-gradient-to-br from-gray-300 to-gray-500",
        imgSrc: darkMode ? "/img/working-white.png" : "/img/working.png",
        link: "/experiencia"
      },
      {
        title: t.projectsTitle,
        image: "bg-gradient-to-br from-gray-200 to-gray-600",
        imgSrc: darkMode ? "/img/programming-white.png" : "/img/programming.png",
        link: "/proyectos"
      },
    ];

    return (
      <section className={`py-20 px-12 transition-colors duration-300 ${
        darkMode ? 'bg-gray-800' : 'bg-stone-200'
      }`}>
        <AnimatedSection animationType="fadeInUp">
          <h2
            id="explora"
            className={`scroll-mt-48 text-5xl font-semibold mb-16 transition-colors duration-300 ${
              darkMode ? 'text-gray-100' : 'text-gray-700'
            }`}
            style={{ fontFamily: "Space Grotesk, sans-serif" }}
          >
            {t.explore}
          </h2>        </AnimatedSection>        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {sections.map((section, index) => (
            <AnimatedSection 
              key={index} 
              animationType="fadeInUp" 
              delay={index * 100} 
              threshold={0.1}
            >
              <div className="opacity-100">
                <Link 
                  to={section.link}
                  className="group cursor-pointer text-center block transform hover:scale-105 transition-transform duration-300"
                >
                  <div className="h-48 mb-2 flex items-end justify-center">
                    <img 
                      src={section.imgSrc} 
                      alt={section.title}
                      className="w-48 h-48 object-contain opacity-70 group-hover:opacity-90 transition-opacity"
                    />
                  </div>
                  <h3 className={`text-xl font-medium transition-colors duration-300 ${
                    darkMode 
                      ? 'text-gray-200 group-hover:text-red-400' 
                      : 'text-gray-800 group-hover:text-red-900'
                  }`}>
                    {section.title}
                  </h3>
                </Link>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </section>
    );
  };  // Social Networks Section
  const SocialSection = () => {
    const text = t.socialNetworks;
    return (      <section className="bg-red-900 pt-20 pb-12 px-12 relative overflow-hidden">
        <div className="text-center relative z-10">
          <AnimatedSection animationType="fadeInUp">
            <h2
              className="text-6xl lg:text-8xl font-bold text-white mb-12 flex justify-center flex-wrap"
              style={{ fontFamily: "Space Grotesk, sans-serif" }}
            >
              {text.split("").map((char, idx) => (
                <span
                  key={idx}
                  className="inline-block animate-wave"
                  style={{
                    animationDelay: `${idx * 0.08}s`,
                    marginRight: char === " " ? "0.3em" : "0",
                  }}
                >
                  {char}
                </span>
              ))}{" "}
            </h2>{" "}
          </AnimatedSection>
          {/* Íconos de redes sociales */}
          <AnimatedSection animationType="fadeInUp" delay={400}>
            <div className="flex justify-center gap-6 mt-20">
            {/* Instagram */}
            <a
              href="https://www.instagram.com/ine.vaz"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="w-12 h-12 bg-white rounded-full flex items-center justify-center hover:scale-110 transition-transform cursor-pointer shadow-lg hover:shadow-xl"
            >
              <FaInstagram className="text-red-900 text-2xl" />
            </a>

            {/* LinkedIn */}
            <a
              href="https://linkedin.com/in/inevaz" // Cambiar por tu perfil de LinkedIn
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-white rounded-full flex items-center justify-center hover:scale-110 transition-transform cursor-pointer shadow-lg hover:shadow-xl"
            >
              <FaLinkedin className="text-red-900 text-2xl" />
            </a>

            {/* GitHub */}
            <a
              href="https://github.com/inevaz" // Cambiar por tu usuario de GitHub
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-white rounded-full flex items-center justify-center hover:scale-110 transition-transform cursor-pointer shadow-lg hover:shadow-xl"
            >
              <FaGithub className="text-red-900 text-2xl" />            </a>
          </div>
          </AnimatedSection>
        </div>
      </section>
    );  };// No Contact Section in home page - moved to its own page
  
  return (
    <div 
      style={{ fontFamily: "Raleway, sans-serif" }} 
      className={`min-h-screen transition-colors duration-300 ${
        darkMode ? 'bg-gray-900 text-white' : 'bg-stone-200 text-gray-900'
      }`}
    >
      <link
        href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=Raleway:wght@300;400;500;600;700&display=swap"
        rel="stylesheet"
      />

      <WaveText />      <Navigation 
        isDarkMode={darkMode} 
        setIsDarkMode={setIsDarkMode} 
        language={currentLanguage} 
        setLanguage={setLanguage} 
      />
      <HeroSection />      <ExploreSection />      <SocialSection />
      <Footer isDarkMode={darkMode} language={currentLanguage} />
    </div>
  );
};

export default PortfolioHome;
